import LoginWithBackGroundImageContainer from "../../../../Components/OtherPages/Authentication/LoginWithBackGroundImage/LoginWithBackGroundImage"

const LoginWithBackGroundImage = () => {
  return (
    <div className='page-body'>
      <LoginWithBackGroundImageContainer />
    </div>
  )
}

export default LoginWithBackGroundImage